import './cookie-banner.js';

/** Landing page — form submit handler */

const form = document.querySelector('.landing-form');
const successMsg = document.getElementById('successMsg');

if (form) {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const data = new FormData(form);

    try {
      await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(data).toString(),
      });
      form.hidden = true;
      successMsg.hidden = false;
    } catch {
      // Fallback: let Netlify handle it natively
      form.submit();
    }
  });
}
